<script setup>
import {OhVueIcon} from 'oh-vue-icons';
import {computed} from "vue";


const props = defineProps({
    inputType: {
        type: String,
        default: "text",
    },
    maxValue: {
        type: Number,
        default: null,
    },
    modelValue: {
        type: [String, Number],
        default: null,
    },

});

const emit = defineEmits(['update:modelValue'])

const value = computed({
    get() {
        return props.modelValue
    },
    set(value) {
        emit('update:modelValue', value)
    }
})

function sanitizeValue(event) {
    const value = parseInt(event.target.value);

    let sanitizedValue = value;

    if (isNaN(value) || value < 0) {
        sanitizedValue = null;
    } else if (props.maxValue && value > props.maxValue) {
        sanitizedValue = props.maxValue
    }

    event.target.value = sanitizedValue;
    return sanitizedValue;
}
</script>
<template>
    <div class="relative w-36">
        <div
            v-if="value"
            class="absolute inset-y-0 right-0 flex items-center pr-7 pointer-events-none"
        >
            <OhVueIcon name="hi-check" class="text-green-700"/>
        </div>
        <input
            @input="value = sanitizeValue($event)"
            :value="value"
            :max="props.maxValue"
            :type="props.inputType"
            class="inline-block w-20 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-1.5"
            min="0"
        />
    </div>
</template>
